const interests = [
    "Artificial Intelligence",
    "Game Developer",
    "Computer Network",
    "Graphics Design",
    "Information Security",
    "Data Science",
]

export {interests}